import React from 'react';

export default function NoResults() {
  return (
    <div className="w-full p-2 lg:px-3.75 lg:py-3 font-semibold">
      <p>{Craft.t('catalog', 'No products available.')}</p>
      <p>{Craft.t('catalog', 'Try to reset your applied filters.')}</p>
    </div>
  );
}
